import React, { useEffect, useState } from "react";
// import Tabs from './tabs';
import "./css.css";
import img1 from "../img/GLNG_1D.png";
import img2 from "../img/GLNG_1M.png";
import img3 from "../img/GLNG_1Y.png";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";

import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function
 **/

export const Page4 = (props) => {
  const [pic, setPic] = useState(img1);
  const [estimation, setConfidence] = useState(true);
  const history = useNavigate();
  const [url, setUrl] = useState(window.location.href);
  const [userId, setUserId] = useState("");
  const [key, setKey] = useState('page4_1D');
  const [selectedValue, setSelectedValue] = useState(50);
  const [isRangeMoved, setIsRangeMoved] = useState(false);

  const handleRangeChange = (event) => {
    setSelectedValue(event.target.value);
  };

  async function addclick(data) {
    console.log(data);
    const docRef = await addDoc(collection(db, "clicksdata"), {data,});
  }

  const submit = async () => {
    console.log(selectedValue);
    localStorage.setItem("page4_confidence",selectedValue);
    const page4_confidence_button = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: "page4_confidence_button",
    };
    history(`/page4A/?,${userId}`);
    addclick(page4_confidence_button);
  }

  const button = async (eventKey) => { 
    setKey(eventKey)
    const clickdata = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: eventKey
    };
    addclick(clickdata);
    if (eventKey === "page4_1D") {
      setPic(img1);
    }
    if (eventKey === "page4_1M") {
      setPic(img2);
    }
    if (eventKey === "page4_1Y") {
      setPic(img3);
    }
  }  

  useEffect(() => {
    const iosa = url.split(",");
    setUserId(iosa[1]);
  }, []);

  return (
    <div className="main">
      <div className="header">
        <h1>CORPORATION W</h1>
        <h3>Current Price: 46.55 USD</h3>
      </div>
      <div className="grid">
        <div className="webtabs">
          <Tabs
            defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3" activeKey={key}
            onSelect={(e) => button(e)}
          >
            <Tab eventKey="page4_1D" title="1D">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page4_1M" title="1M">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page4_1Y" title="1Y">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page4_details" title="Details">
              {/* <img className="img1" src={pic} alt="" /> */}
              <table class="table table-hover table-dark table-striped">
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>Open</td>
                    <td>46.65</td>
                    <td>Beta</td>
                    <td>1.79</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>High</td>
                    <td>46.8</td>
                    <td>Avg Volume</td>
                    <td>774990</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Low</td>
                    <td>46</td>
                    <td>Market Cap</td>
                    <td>30102323.63</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Close</td>
                    <td>46.55</td>
                    <td>52 Week High</td>
                    <td>47.5</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Adj Close</td>
                    <td>40.63</td>
                    <td>52 Week Low</td>
                    <td>30.51</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Volume</td>
                    <td>928000</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="page4_profile" title="Profile">
              {/* <img className="img" src={pic} alt="" /> */}
              <p className="profileinfo"> Sector: Energy <br></br><br></br>
                This corporation plans, possesses, and handles nautical infrastructure for the solidifying of natural gas. <br></br>
                The firm runs via three sectors: floating liquefied natural gas, business and miscellaneous, and cargo transportation. <br></br>
                Moreover, it participates in the re-vaporization, keeping, and unloading of solidified natural gas; <br></br> 
                management of drifting solidification natural gas ships; management of the transportation of liquefied natural gas carriers; and ship regulation.
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="info">

        {estimation ? (
            <div class="text-center">
              <div>
                <h1>YOUR INITIAL PREDICTION</h1>
                <p>Based on the information available, what is your prediction of the stock's price, in $, exactly one month later?
                </p>
              </div>
              <Formik
                initialValues={{ page4_prediction: "" }}
                onSubmit={(values) => {
                  console.log(values.page4_prediction);
                  localStorage.setItem("page4_prediction", values.page4_prediction);
                  const page4_prediction_button = {
                    time: Date.now(),
                    userId: localStorage.getItem("user_id"),
                    buttonType: "page4_prediction_button"
                  };
                  addclick(page4_prediction_button);
                  setConfidence(false);
                }}
                validationSchema={Yup.object({
                  page4_prediction: Yup.number().max(10000).min(0).required("prediction is required")
                })}
              >
                {(formik, isSubmitting) => (
                  <Form>
                    <div className="d-flex justify-content-center">
                      <div className="col-sm-4">
                        <Field name="page4_prediction" className={ formik.touched.page4_prediction && formik.errors.page4_prediction ? "form-control is-invalid" : "form-control" } type="text" placeholder="numbers only"/>
                      </div>
                    </div>
                    <br></br>
                    <div class="text-center">
                      <Button variant="dark" className="estbutton" type="submit">Submit</Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div class="text-center">
              <div>
                <h1>YOUR CONFIDENCE LEVEL</h1>
                <p> Please move the marker to indicate how confident you are that your prediction is accurate, from 0 to 100. 
                  <span className="marker_span"><br></br>0- I am definitely wrong.
                  100- I am definitely right. </span><br></br>
                </p>
              </div>
              <Form1.Range name="page4_confidence" value={selectedValue} onChange={handleRangeChange} onInput={() => setIsRangeMoved(true)}/>
              <p>Confidence level: {isRangeMoved ? selectedValue : "none"}</p>
              <Button variant="dark" className="estbutton" type="submit" onClick={submit} disabled={!isRangeMoved}>Submit</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
